import { LoadingState, SectionHeader } from '../../../shared/components/index.js';
import { useLeadsData } from '../hooks/useLeadsData.jsx';
import HtmlBlock from '../components/HtmlBlock.jsx';
import { buildAgingHtml, buildFunnelHtml } from '../utils/present-leads-html.js';

export default function LeadsEmbudoPage() {
  const { loading, data } = useLeadsData();
  if (loading && !data) return <LoadingState />;
  return (
    <div className="analytics-grid-2">
      <section className="analytics-section">
        <SectionHeader
          title="Embudo comercial"
          note="Stock abierto ahora · barras por etapa · semáforo de antigüedad/SLA del backend."
        />
        <HtmlBlock
          html={buildFunnelHtml(data && data.funnel, (data && data.funnelByStage) || [])}
          className="analytics-panel"
        />
      </section>
      <section className="analytics-section">
        <SectionHeader title="Antigüedad de leads abiertos" note="Desde creación · no es tiempo en etapa." />
        <HtmlBlock
          html={buildAgingHtml((data && data.agingSinceCreation) || [], data && data.dataQuality)}
          className="analytics-panel"
        />
      </section>
    </div>
  );
}
